// extracted by mini-css-extract-plugin
export var $animation_name = "Post-module--$animation_name--e4ffc";
export var Post = "Post-module--Post--29a43";
export var PostsContainer = "Post-module--PostsContainer--dcc02";
export var PostsContainer__slider = "Post-module--PostsContainer__slider--caeca";